import React, { useEffect, useCallback, useRef } from 'react';
import { InputGroup, InputLeftElement, Input } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { useLocation } from 'react-router-dom'; // Import useLocation
import colors from "common/theme/foundations/colors";
const CustomSearchInput = React.memo(({
  allData,
  setSearchbox,
  setDisplaySearchData,
  searchbox,
  handleSearchChange,
  dataColumn,
  onSearch,
  setGetTagValues,
  setGopageValue,

  isKanban = false,
  source = ''

}) => {
  const debounceTimeout = useRef(null);
  const inputRef = useRef(null);
  const location = useLocation(); 

  const preserveFocus = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const savedSearchTerm = localStorage.getItem('searchTerm');

    if (savedSearchTerm) {
      setSearchbox(savedSearchTerm);
    }
  }, [setSearchbox]);

  useEffect(() => {
    // Clear search box when route changes
    setSearchbox('');
    setDisplaySearchData(false);
    setGetTagValues([]);
  }, [location]); 

  const handleInputChange = useCallback((e) => {
    const originalValue = e.target.value || '';
    const lowercasedValue = originalValue.toLowerCase();

    setSearchbox(originalValue);
    setDisplaySearchData(!!originalValue);
    setGetTagValues([]);

    const wasFocused = document.activeElement === inputRef.current;

    if (!originalValue && setGopageValue) {
      setGopageValue(1);
    }

    localStorage.setItem('searchTerm', originalValue);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      if (handleSearchChange) {
        handleSearchChange(lowercasedValue); // Send lowercase to search
      }

    }, 800);
  }, [
    handleSearchChange,
    setSearchbox,
    setDisplaySearchData,
    setGetTagValues,
    setGopageValue,
    preserveFocus
  ]);

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  return (
    <InputGroup
      width={'100%'}
      maxWidth={'251px'}
      mx={{ sm: 0, md: 3 }}
      my={{ sm: "8px", md: "0" }}
      className="search-input"
    >
      <InputLeftElement
        size="sm"
        top="-3px"
        pointerEvents="none"
        zIndex="0"
        children={<SearchIcon className="customSearchIcon" color={colors.iconDark} />}
      />
      <Input
        ref={inputRef}
        type="text"
        size="sm"
        fontSize="sm"
        value={searchbox}
        onChange={handleInputChange}
        fontWeight="400"
        placeholder="Search"
        borderRadius="16px"
      />
    </InputGroup>
  );
});

export default CustomSearchInput;
